<template>
  <div>
    <md-card v-if="quote">
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-icon">
          <md-icon>attach_money</md-icon>
        </div>
        <h4 class="title">Quotes</h4>
      </md-card-header>
      <md-card-content>
        <md-card>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Value:</strong>
                  <br />
                  &#163;{{ quote.value }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Priority:</strong>
                  <br />
                  {{ quotePriority(quote.quotePriority).name }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p
                  v-bind:class="'text-' + quoteStatus(quote.quoteStatus).colour"
                >
                  <strong>Status:</strong>
                  <br />
                  {{ quoteStatus(quote.quoteStatus).name }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <strong>Last Updated:</strong>
                <br />
                <i
                  >{{ quote.lastUpdatedDate | moment("MMMM Do YYYY HH:mm") }} -
                  {{ quote.lastUpdatedBy }}
                </i>
              </div>
            </div>
            <md-card-actions v-if="quote.quoteStatus < 5">
              <status-button
                :statusId="6"
                :classColour="quoteStatus(6).colour"
                icon="restore"
                :text="quoteStatus(6).name"
                :visible="setVisibility(quote.quoteStatus, 6)"
                :role="2"
                @change-status="setShowModal(6, quote.id)"
              ></status-button>
              <status-button
                :statusId="7"
                :classColour="quoteStatus(7).colour"
                icon="restore"
                :text="quoteStatus(7).name"
                :visible="setVisibility(quote.quoteStatus, 7)"
                @change-status="setShowModal(7, quote.id)"
              ></status-button>
              <status-button
                :statusId="2"
                classColour="success"
                icon="restore"
                :text="quoteStatus(2).name"
                :visible="setVisibility(quote.quoteStatus, 2)"
                :role="2"
                @change-status="setShowModal(2, quote.id)"
              ></status-button>
              <status-button
                :statusId="3"
                classColour="success"
                icon="restore"
                :text="quoteStatus(3).name"
                :visible="setVisibility(quote.quoteStatus, 3)"
                @change-status="setShowModal(3, quote.id)"
              ></status-button>
              <status-button
                :statusId="4"
                classColour="success"
                icon="restore"
                :text="quoteStatus(4).name"
                :visible="setVisibility(quote.quoteStatus, 4)"
                @change-status="setShowModal(4, quote.id)"
              ></status-button>
              <status-button
                :statusId="5"
                classColour="success"
                icon="restore"
                :text="quoteStatus(5).name"
                :visible="setVisibility(quote.quoteStatus, 5)"
                @change-status="setShowModal(5, quote.id)"
              ></status-button>
            </md-card-actions>
          </md-card-content>
        </md-card>
      </md-card-content>
    </md-card>
    <md-card v-if="historicStatInspItemQuotes.length > 0">
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-icon">
          <md-icon>attach_money</md-icon>
        </div>
        <h4 class="title">Previous quotes</h4>
      </md-card-header>
      <md-card-content>
        <md-card
          v-for="quote in historicStatInspItemQuotes"
          :key="quote.id"
          :value="quote.id"
        >
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Value:</strong>
                  <br />
                  &#163;{{ quote.value }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Priority:</strong>
                  <br />
                  {{ quotePriority(quote.quotePriority).name }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p
                  v-bind:class="'text-' + quoteStatus(quote.quoteStatus).colour"
                >
                  <strong>Status:</strong>
                  <br />
                  {{ quoteStatus(quote.quoteStatus).name }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <strong>Last Updated:</strong>
                <br />
                <i
                  >{{ quote.lastUpdatedDate | moment("MMMM Do YYYY HH:mm") }} -
                  {{ quote.lastUpdatedBy }}
                </i>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </md-card-content>
    </md-card>
    <QuoteChangeStatusModal
      :showModal="showModal"
      :newStatusId="selectedStatusId"
      :quoteId="selectedQuoteId"
      @closeModal="closeModal"
    ></QuoteChangeStatusModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "stat-insp-item-quotes",
  components: {
    QuoteChangeStatusModal: () =>
      import("../../../quotes/components/QuoteChangeStatusModal")
  },
  data() {
    return {
      showModal: false,
      selectedStatusId: 1,
      selectedQuoteId: undefined
    };
  },
  computed: {
    ...mapGetters({
      quoteStatus: "quote/getQuoteStatus",
      statInsp: "stat-insp/statInsp",
      quote: "stat-insp/statInspItemQuote",
      historicStatInspItemQuotes: "stat-insp/statInspItemPreviousQuotes",
      quotePriority: "quote/getQuotePriority"
    })
  },
  methods: {
    setShowModal(statusId, quoteId) {
      this.selectedStatusId = statusId;
      this.selectedQuoteId = quoteId;
      this.showModal = true;
    },
    closeModal(refresh) {
      this.showModal = false;
      if (refresh) {
        this.$emit("refresh");
      }
    },
    setVisibility(currentStatusId, newStatusId) {
      if (this.statInsp.isPartial) return false;

      switch (newStatusId) {
        case 2:
          return currentStatusId === 1;
        case 3:
          return currentStatusId === 2;
        case 4:
          return currentStatusId === 3;
        case 5:
          return currentStatusId === 4;
        case 6:
          return currentStatusId === 1;
        case 7:
          return currentStatusId === 2;
      }
      return false;
    }
  }
};
</script>

<style></style>
